<!-- youtube-mobile-01 preview — YouTube in-stream (skippable, mobile watch page) -->
<app-mobile-frame>
  <!-- START: Watch screen -->
  <div class="ytv-ism-screen">
    <!-- START: Player running the video -->
    <div class="ytv-ism-player">
      <img
        *ngIf="thumbnailUrl; else noCreative"
        class="ytv-ism-creative"
        [src]="thumbnailUrl"
        alt=""
      />

      <ng-template #noCreative>
        <div class="ytv-ism-creative ytv-ism-missing">
          <ng-container *ngIf="isResolving; else askForVideo">
            Reading video format&hellip;
          </ng-container>
          <ng-template #askForVideo>Add a {{ format }} video to see this preview</ng-template>
        </div>
      </ng-template>

      <!-- Player chrome. Fixed copy: it is the player's frame, not the author's.
           Only drawn over a creative. -->
      <ng-container *ngIf="thumbnailUrl">
        <span class="ytv-ism-visit">Visit Advertiser</span>
        <span class="ytv-ism-skip">Skip Ad <i class="bi bi-skip-end-fill"></i></span>
        <span class="ytv-ism-countdown">00:16</span>
        <div class="ytv-ism-progress"><span class="ytv-ism-progress-fill"></span></div>
      </ng-container>
    </div>
    <!-- END: Player -->

    <!-- START: Info row -->
    <div class="ytv-ism-row">
      <img
        class="ytv-ism-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />

      <div class="ytv-ism-text">
        <div class="ytv-ism-headline">{{ headline }}</div>
        <div class="ytv-ism-meta"><strong>Sponsored</strong> &middot; {{ displayUrl }}</div>
      </div>

      <a
        class="ytv-ism-cta"
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        >{{ data.ctaText || "Your call to action" }}</a
      >
    </div>
    <!-- END: Info row -->

    <!-- START: Skeleton of the rest of the page -->
    <div class="ytv-ism-skeleton">
      <div class="ytv-ism-bar ytv-ism-bar-long"></div>
      <div class="ytv-ism-bar ytv-ism-bar-long ytv-ism-bar-mid"></div>
      <div class="ytv-ism-bar ytv-ism-bar-short"></div>

      <div class="ytv-ism-person">
        <span class="ytv-ism-dot"></span>
        <span class="ytv-ism-bar ytv-ism-bar-name"></span>
      </div>

      <div class="ytv-ism-chips">
        <span class="ytv-ism-chip ytv-ism-chip-a"></span>
        <span class="ytv-ism-chip ytv-ism-chip-b"></span>
        <span class="ytv-ism-chip ytv-ism-chip-c"></span>
        <span class="ytv-ism-chip ytv-ism-chip-d"></span>
      </div>

      <div class="ytv-ism-block"></div>
    </div>
    <!-- END: Skeleton -->
  </div>
  <!-- END: Watch screen -->
</app-mobile-frame>
